export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Infoadicional.vue?vue&type=template&id=478cb0d2&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/DetailsResidencial/Infoadicional.vue?vue&type=template&id=478cb0d2&
// module id = null
// module chunks = 